import BaseChannel from "~/channels/BaseChannel";

export default class PingChannel extends BaseChannel {
  static channelName = "PingChannel";
}
